import AlternateUsers from '../Pages/AlternateUsers';
import AnalyticsScreen from '../Pages/Analytics';
import ForgotPassword from '../Pages/Auth/ForgotPassword';
import Login from '../Pages/Auth/Login';
import Register from '../Pages/Auth/Register';
import ResetPassword from '../Pages/Auth/ResetPassword';
import ChatDetailScreen from '../Pages/ChatDetail';
import ChatScreen from '../Pages/Chats';
import ContactsScreen from '../Pages/Contacts';
import CustomerScreen from '../Pages/Customers';
import Groups from '../Pages/Groups';
import SettingScreen from '../Pages/Settings';
import TemplatesScreen from '../Pages/Templates';
import UsersScreen from '../Pages/Users';

export const getRoutes = (role) => {
  return {
    register: {
      permission: false,
      path: '/auth/register',
      name: 'Register',
      route: () => '/auth/register',
      element: Register,
    },
    login: {
      permission: false,
      path: '/auth/login',
      name: 'Login',
      route: () => '/auth/login',
      element: Login,
    },
    forgot_password: {
      permission: false,
      path: '/auth/forgot-password',
      name: 'Forgot Password',
      route: () => '/auth/forgot-password',
      element: ForgotPassword,
    },
    reset_password: {
      permission: false,
      path: '/auth/reset-password',
      name: 'Reset Password',
      route: (id) => `/auth/reset-password`,
      element: ResetPassword,
    },
    chats: {
      permission: true,
      path: '/chat',
      name: 'Chats',
      route: () => '/chat',
      element: ChatScreen,
    },
    chat_detail: {
      permission: true,
      path: '/chat/:userId',
      name: 'Chat Detail',
      route: (userId) => `/chat/${userId}`,
      element: ChatDetailScreen,
    },
    groups: {
      permission: true,
      path: '/groups',
      name: 'Groups',
      route: () => '/groups',
      element: Groups,
    },
    groups_detail: {
      permission: true,
      path: '/groups/:groupId',
      name: 'Group Detail',
      route: (groupId) => `/groups/${groupId}`,
      element: Groups,
    },
    users: {
      permission: true,
      path: '/users',
      name: 'Users',
      route: () => '/users',
      element: UsersScreen,
    },
    alternate_users: {
      permission: true,
      path: '/users/alternate',
      name: 'Alternate Users',
      route: () => '/users/alternate',
      element: AlternateUsers,
    },
    customers: {
      permission: true,
      path: '/customers',
      name: 'Customers',
      route: () => '/customers',
      element: CustomerScreen,
    },
    contacts: {
      permission: true,
      path: '/contacts',
      name: 'Contacts',
      route: () => '/contacts',
      element: ContactsScreen,
    },
    analytics: {
      permission: true,
      path: '/analytics',
      name: 'Analytics',
      route: () => '/analytics',
      element: AnalyticsScreen,
    },
    templates: {
      permission: true,
      path: '/templates',
      name: 'Templates',
      route: () => '/templates',
      element: TemplatesScreen,
    },
    settings: {
      permission: true,
      path: '/settings',
      name: 'Settings',
      route: () => '/settings',
      element: SettingScreen,
    },
  };
};
